<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <div class="p-7 space-y-5">
    <div class="flex items-start justify-between mb-4">
      <div class="flex items-start gap-2.5">
        <div
          class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
        >
          <igntr-icon name="globe"></igntr-icon>
        </div>
        <div>
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ "msGraphOptions" | transloco }}
          </div>
          <div class="text-[12px] !text-slate-500 mt-0.5">
            {{ emailTemplateItems.length }} microsoft graph
          </div>
        </div>
      </div>
      <button
        class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium inline-flex items-center gap-1.5"
        (click)="openModal('')"
      >
        <igntr-icon name="plus"></igntr-icon>
        {{ "new" | transloco }}
      </button>
    </div>
    <div
      class="rounded-xl border !border-slate-200/70 bg-white divide-y divide-slate-100"
      *ngIf="emailTemplateItems.length > 0"
    >
      <div
        class="flex items-center gap-3 px-3.5 py-3"
        *ngFor="let mg of emailTemplateItems"
      >
        <div
          class="w-8 h-8 rounded-lg bg-slate-100 !text-slate-600 flex items-center justify-center"
        >
          <igntr-icon name="globe"></igntr-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ mg.title }}
          </div>
          <!-- <div class="text-[14px] !text-slate-500">
            Head · Allan K. Andreasen
          </div> -->
        </div>
        <!-- <div class="text-right">
          <div class="font-mono text-[14px] !text-slate-900 tabular-nums">
            4
          </div>
          <div class="text-[10px] uppercase tracking-[0.1em] !text-slate-400">
            people
          </div>
        </div> -->
        <button
          class="!text-slate-400 hover:!text-slate-700"
          [matMenuTriggerFor]="toolBoxMenu"
        >
          <igntr-icon name="dots"></igntr-icon>
        </button>
        <mat-menu #toolBoxMenu="matMenu">
          <button mat-menu-item (click)="openModal(mg.id)">
            {{ "edit" | transloco }}
          </button>
          <button
            mat-menu-item
            class="text-danger"
            (click)="deleteConfirmation = mg"
            title="{{ 'delete' | transloco }}"
          >
            {{ "delete" | transloco }}
          </button>
          <button mat-menu-item (click)="testEmailsOptions(mg.id)">
            {{ "test" | transloco }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<!-- 
<div
  class="d-flex justify-content-between mt-4 mb-2 align-items-end px-2 px-sm-0"
>
  <app-page-title
    [customTitle]="'setMsGraphOptions'"
    [hideDescription]="true"
  ></app-page-title>

  <div style="display: flex; gap: 20px">
    *ngIf="(generalDataRepo.allGeneralData$ | async)?.chatGPTForTenant"
    <p-button
      class="d-none d-sm-block"
      label="{{ 'add' | transloco }}"
      icon="pi pi-plus"
      [routerLink]="['/tenants/emails/new', tenantId]"
    />
  </div>
</div>
<div>
  <p-table
    #dt1
    [value]="emailTemplateItems"
    [globalFilterFields]="['title', 'description']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th colspan="2">
          <div class="col-12 col-xl-10">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-search"></i>
              </p-inputgroup-addon>
              <input
                type="text"
                pInputText
                (input)="onGlobalFilter(dt1, $event)"
                placeholder="{{ 'search' | transloco }}"
              />
            </p-inputgroup>
          </div>
        </th>
        <th class="d-none d-xl-table-cell"></th>
      </tr>
      <tr>
        <th pSortableColumn="title" class="col-xl-4 col-6">
          {{ "name" | transloco }} <p-sortIcon field="title"></p-sortIcon>
        </th>
        <th pSortableColumn="createdAt" class="col-xl-2 col-5">
          {{ "created" | transloco }}
          <p-sortIcon field="createdAt"></p-sortIcon>
        </th>
        <th class="col-1"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-option>
      <tr>
        <td>
          <p class="text-break splice-text">
            {{ option.title }}
          </p>
        </td>
        <td>
          {{ option.createdAt | date: "dd-MM-YYYY HH:mm" }}
        </td>
        <td>
          <div class="d-flex align-items-center justify-content-end">
            <button
              mat-icon-button
              [matMenuTriggerFor]="toolBoxMenu"
              tabindex="-1"
              class="small-icon-button d-flex justify-content-center align-items-center p-0"
              style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
            >
              <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
            </button>
            <mat-menu #toolBoxMenu="matMenu">
              <button mat-menu-item [routerLink]="['emails', option.id]">
                {{ "edit" | transloco }}
              </button>
              <button
                mat-menu-item
                class="text-danger"
                (click)="deleteConfirmation = option"
                title="{{ 'delete' | transloco }}"
              >
                {{ "delete" | transloco }}
              </button>
              <button mat-menu-item (click)="testEmailsOptions(option.id)">
                {{ "test" | transloco }}
              </button>
            </mat-menu>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <p class="text-muted px-3 py-2">{{ "noItemsFound" | transloco }}</p>
    </ng-template>
  </p-table>
</div> -->

<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConfirmation"
  [deleteCandidate]="deleteConfirmation.title"
  (confirm)="handleDeleteClick(deleteConfirmation); deleteConfirmation = null"
  (cancel)="deleteConfirmation = null"
></app-confirm-delete>

<div class="igntr-theme" *ngIf="showModalWindow">
  <div
    class="fixed inset-0 bg-slate-900/20 backdrop-blur-[2px] z-[110]"
    (click)="onCloseModal()"
  ></div>
  <app-tenant-ms-graph-edit-page
    [tenantId]="tenantId"
    [id]="msGraphId"
    (onCloseModal)="onCloseModal()"
    (loadData)="loadData()"
  ></app-tenant-ms-graph-edit-page>
</div>
